export type PriceSummaryItem =
  | Partial<{
      withVat: number;
      withoutVat: number;
      vat: number;
      vatType: string;
    }>
  | undefined;

export const calculatePriceSummary = (prices: PriceSummaryItem[], discount: PriceSummaryItem) =>
  prices.reduce<{withVat: number; withoutVat: number; vat: number}>(
    (acc, curr) => ({
      withVat: acc.withVat + (curr?.withVat ?? 0),
      withoutVat: acc.withoutVat + (curr?.withoutVat ?? 0),
      vat: acc.vat + (curr?.vat ?? 0),
    }),
    {
      withVat: -(discount?.withVat ?? 0),
      withoutVat: -(discount?.withoutVat ?? 0),
      vat: -(discount?.vat ?? 0),
    }
  );
